import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { logout } from "../../../../store/action";
import UserStore from "../../../../store/UserStore";
import LoginService from "../../../../service/Auth/Login";
import AppInfoservice from "../../../../service/common/Appinfo";
import { WORDPRESS_URL } from "../../../../configuration/apiconfig";
function Logout() {
  console.log("i am inside logout");
  const [state, setState] = useState({
    icononly: false,
    logoutUrl: "",
  });

  useEffect(() => {
    const service = new AppInfoservice();
    service.get_layout().then((res) => {
      setState((prev) => ({
        ...prev,
        logoutUrl: res.data.logout_url,
      }));
    });
  }, []);

  const history = useHistory();
  const dispatch = useDispatch();
  const service = new LoginService();
  useEffect(() => {
    service.logOut().then((res) => {
      if (res.status) {
        dispatch(logout());
        localStorage.removeItem("login");
        localStorage.removeItem("apiKey");
        localStorage.removeItem("currency");
        UserStore.key = "";
        // history.push("/login");
        window.location.href =
          state.logoutUrl != ""
            ? state.logoutUrl
            : `${WORDPRESS_URL}register-login`;
      } else {
        dispatch(logout());
        localStorage.removeItem("login");
        localStorage.removeItem("apiKey");
        localStorage.removeItem("currency");
        UserStore.key = "";
        // history.push("/login");
        // window.location.href = state.logoutUrl;
        window.location.href =
          state.logoutUrl != ""
            ? state.logoutUrl
            : `${WORDPRESS_URL}register-login`;
      }
    });
  });
  return <div></div>;
}

export default Logout;
